import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { merge } from 'rxjs';
import { AuthService } from '../../../../../../src/core/services/auth.service';
import { VesselDAO } from '../../../../../core/services/dao/vesselDAO';
import { UserDAO } from '../../../../../core/services/dao/userDAO';
import { map, take } from 'rxjs/operators';
import { ApiHelper } from '../../../../../core/services/apiHelper';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class BoatyardResolve implements Resolve<any> {
  constructor(
    private authService: AuthService,
    private vesselDao: VesselDAO,
    private userDao: UserDAO,
    private apiHelper: ApiHelper,
  ) {
    this.apiHelper.setEnvironment(environment.envName);
  }

  resolve(route: ActivatedRouteSnapshot) {
    let vesselResolve;
    const sessionResolve = this.authService.checkSession();
    const user = this.userDao.getCurrentUser();
    if (user.boatOwner) {
      vesselResolve = this.vesselDao.loadByOwnerId();
    }
    if (user.boatOwner) {
      let mergeResolve = merge(sessionResolve, vesselResolve);
      return mergeResolve.pipe(
        take(2),
        map((data) => data),
      );
    } else {
      return sessionResolve.pipe(
        take(1),
        map((data) => data),
      );
    }
  }
}
